import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monitoring-report',
  templateUrl: './monitoring-report.component.html',
  styleUrls: ['./monitoring-report.component.scss']
})
export class MonitoringReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
